<template>
  <div class="frameParent">
    <div class="frameDiv" v-if="allClasses">
      <div class="textParent">
        <b class="text">{{ $route.query.month }} Class</b>
        <div class="dateHeaderParent">
          <div class="text">
            Start: {{ startDate?.toLocaleDateString() }} <b> | </b> End:
            {{ endDate?.toLocaleDateString() }} <b> | </b>
            {{ studentCount }} Enrolled
          </div>
        </div>
      </div>
      <div class="frameParent1">
        <img
          class="frameIcon"
          alt=""
          :src="classObj.activeInstructor.user.image"
        />
        <div class="frameParent2">
          <div class="programParent">
            <div class="text">
              {{ classObj.activeInstructor.user.userType.name }}
            </div>
            <div>|</div>
            <div class="text">{{ classObj.curriculum.program.name }} Class</div>
          </div>
          <b class="instructorName"
            >{{ classObj.activeInstructor.user.firstName }}
            {{ classObj.activeInstructor.user.lastName }}</b
          >
          <div class="frameParent3">
            <!--            <div
              class="classDocumentsWrapper"
            >
              <div class="classDocuments">Class Documents</div>
            </div>-->
            <div class="classGradeBookWrapper" @click="goToClassGradeBook">
              <div class="classDocuments">Class Gradebook</div>
            </div>
            <!--            <div class="endorsementsWrapper">
              <div class="classDocuments">Endorsements</div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="frameParent4" v-if="classObj">
      <div class="textParent">
        <b class="text">{{ studentCount }} Students</b>
      </div>
      <div style="width: 100%">
        <div class="row">
          <div class="frameParent5">
            <div
              class="frameParent6"
              v-for="(group, i) of displayStudents"
              v-bind:key="i"
            >
              <div
                class="frameParent7"
                :class="cardClass(group.length)"
                v-for="student of group"
                v-bind:key="student.id"
                @click="selectStudent(student.user.id)"
              >
                <div class="numberInner">
                  <div class="frameParent8">
                    <div class="studentNameParent">
                      <b class="studentName"
                        >{{ student.user.firstName }}
                        {{ student.user.lastName }}</b
                      >
                      <div class="gradeValue">
                        Grade: {{ student.averageGrade.toFixed(1) }}%
                      </div>
                    </div>
                    <div class="frameParent9">
                      <div class="optionsParent">
                        <b
                          class="text"
                          :class="classColor(student.daysMargin, 'days')"
                          >{{ student.daysMargin }}</b
                        >
                        <img
                          class="optionsIcon"
                          alt=""
                          src="/static/img/vertical_dots.svg"
                        />
                      </div>
                      <div
                        class="daysAheadWrapper"
                        :class="classColor(student.daysMargin, 'dayLabel')"
                      >
                        <div class="text">
                          <span v-if="student.daysMargin >= 0">Days Ahead</span>
                          <span v-else>Days Behind</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--                <div class="frameParent10">
                  <div class="buttonWrapper">
                    <div class="classDocuments">Grade Book</div>
                  </div>
                  <div class="buttonWrapper">
                    <div class="classDocuments">Log Book</div>
                  </div>
                </div>-->
                <div class="hoursContainer" :id="'hoursContainer' + student.id">
                  <div class="hoursWrapper" :id="'hours' + student.id">
                    <div class="text">
                      {{ student.flightHours.toFixed(1) }}/{{
                        classObj.curriculum.requiredFlightHours
                      }}
                      Hours
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CourseDetails v-if="selectedStudent" :canNavigateBack="false" />
    <add-student
      :isVisible="openAddStudent"
      @close="toggleOpenAddStudent"
      @add="addStudentsToClass"
    ></add-student>
  </div>
</template>
<script>
import { getProcessedImageUrl } from "@/util/images";
import { useLoginStore } from "../../../stores/loginStore";
import AddStudent from "./Classroom/ClassroomComponents/AddStudent.vue";
import CourseDetails from "@/pages/Dashboard/HiloPages/Classroom/CourseDetails/CourseDetails.vue";
import ClassesAPIService from "../../../servicehandlers/ClassesAPIService";

const classesAPIService = new ClassesAPIService();
export default {
  name: "Frame",
  components: {
    AddStudent,
    CourseDetails,
  },
  data() {
    return {
      classId: null,
      allClasses: null,
      classObj: null,
      startDate: null,
      endDate: null,
      displayStudents: [],
      openAddStudent: false,
      user: useLoginStore().getUser,
      studentCount: 0,
      selectedStudent: null,
    };
  },
  mounted() {
    this.getClassesForInstructor();
  },
  methods: {
    getClassesForInstructor() {
      return classesAPIService
        .getClassesDetailsForInstructor(this.user.id, this.$router)
        .then((response) => {
          this.allClasses = response;
          this.classObj = response[0];
          this.displayStudents = [];
          this.classObj.activeInstructor.user.image = getProcessedImageUrl(
            this.classObj.activeInstructor.user.image,
          );

          for (let classObj of response) {
            classObj.startDate = new Date(classObj.startDate);
            classObj.endDate = new Date(classObj.endDate);
            if (this.startDate > classObj.startDate || !this.startDate) {
              this.startDate = classObj.startDate;
            }
            if (this.endDate < classObj.endDate || !this.endDate) {
              this.endDate = classObj.endDate;
            }
            this.studentCount += classObj.students.length;
            let temp = [];
            for (let student of classObj.students) {
              if (response.indexOf(classObj) !== 0) {
                temp = this.displayStudents[this.displayStudents.length - 1];
              }
              if (temp.length === 3) {
                this.displayStudents.push(temp);
                temp = [];
              }
              if (student) temp.push(student);
            }
            if (!this.displayStudents.includes(temp)) {
              this.displayStudents.push(temp);
            }
          }

          this.$nextTick(() => {
            this.updateDisplay();
          });
        });
    },
    goToClassGradeBook() {
      this.$router.push({
        name: "Admin Class Grade Book",
        query: {
          classId: this.classId,
        },
      });
    },
    cardClass(length) {
      switch (length) {
        case 3:
          return "col-sm-4";
        case 2:
          return "col-sm-6";
        case 1:
          return "col-sm-12";
      }
    },
    toggleOpenAddStudent() {
      this.openAddStudent = !this.openAddStudent;
    },
    addStudentsToClass(selectedStudents) {
      for (let id of selectedStudents) {
        let temp = {
          activeStudentId: id,
          classId: this.classObj.id,
        };
        addStudent(temp, this.$router);
      }

      this.getClassDetails();

      function addStudent(data, router) {
        return classesAPIService.addStudentToClass(data, router);
      }
    },
    classColor(value, type) {
      let className = "";
      switch (type) {
        case "days":
          if (value >= 0) {
            className = "greenText";
          } else if (value === -1) {
            className = "yellowText";
          } else if (value === -2) {
            className = "orangeText";
          } else {
            className = "redText";
          }
          break;
        case "dayLabel":
          if (value >= 0) {
            className = "greenBackground";
          } else if (value === -1) {
            className = "yellowBackground";
          } else if (value === -2) {
            className = "orangeBackground";
          } else {
            className = "redBackground";
          }
          break;
      }
      return className;
    },
    updateDisplay() {
      for (let group of this.displayStudents) {
        for (let student of group) {
          let containerWidth = document.getElementById(
            "hoursContainer" + student.id,
          ).offsetWidth;
          let hoursDiv = document.getElementById("hours" + student.id);
          if (hoursDiv) {
            hoursDiv.style.width = `${containerWidth * (student.flightHours / this.classObj.curriculum.requiredFlightHours)}px`;
          }
        }
      }
    },
    selectStudent(studentId) {
      this.selectedStudent = this.allClasses.find((data) =>
        data.students.find((student) => student.user.id === studentId),
      );
      let curriculumId = this.allClasses.find((data) =>
        data.students.some((student) => student.user.id === studentId),
      ).curriculumId;
      this.$router
        .replace({ query: { curriculumId, studentId } })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
    },
  },
};
</script>
<style scoped>
.text {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dateHeaderParent {
  height: 17px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-size: 15px;
  color: rgba(64, 64, 64, 0.5);
}

.textParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.frameIcon {
  width: 150px;
  border-radius: 22.5px;
  height: 150px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: cover;
}

.programParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 0 0 10px;
  gap: 20px;
}

.instructorName {
  align-self: stretch;
  position: relative;
  font-size: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.classDocuments {
  position: relative;
  display: -webkit-inline-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.classGradeBookWrapper {
  align-self: stretch;
  flex: 1;
  border-radius: 5px;
  background-color: rgba(64, 64, 64, 0.5);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 20px;
  box-sizing: border-box;
  max-width: 200px;
  cursor: pointer;
}

.frameParent3 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  text-align: center;
  font-size: 15px;
  color: #fff;
}

.frameParent2 {
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.frameParent1 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
}

.frameDiv {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 50px;
  gap: 20px;
  z-index: 5;
}

.studentName {
  align-self: stretch;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gradeValue {
  align-self: stretch;
  position: relative;
  font-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.studentNameParent {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 5px;
  max-width: 77.5%;
}

.optionsIcon {
  width: 10px;
  position: relative;
  height: 20px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain;
  cursor: pointer;
}

.optionsParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}

.daysAheadWrapper {
  align-self: stretch;
  border-radius: 5px;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  box-sizing: border-box;
  text-align: left;
  font-size: 15px;
  color: #fff;
}

.frameParent9 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 7px;
  text-align: center;
}

.frameParent8 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.hoursWrapper {
  width: 100%;
  background-color: #00a551;
  height: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 20px;
  box-sizing: border-box;
  border-radius: 100px;
}

.hoursContainer {
  align-self: stretch;
  border-radius: 100px;
  background-color: rgba(64, 64, 64, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 10px;
  color: #fff;
}

.frameParent7 {
  flex: 1;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px;
  gap: 10px;
  cursor: pointer;
}

.frameParent6 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 30px;
}

.frameParent5 {
  width: 100%;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 30px;
  font-size: 40px;
}

.frameParent4 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 50px;
  gap: 15px;
  z-index: 4;
}

.numberInner {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.frameParent {
  height: 100%;
  flex: 1;
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
  text-align: left;
  font-size: 25px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
.actionButton {
  background-color: transparent;
  color: #404040;
  opacity: 50%;
}
.greenText {
  color: #00a551;
}
.yellowText {
  color: #eece01;
}
.orangeText {
  color: #da7704;
}
.redText {
  color: #ba0000;
}
.greenBackground {
  background-color: #00a551;
}
.yellowBackground {
  background-color: #eece01;
}
.orangeBackground {
  background-color: #da7704;
}
.redBackground {
  background-color: #ba0000;
}
</style>
